module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "frontmt"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v("Be it enacted by the Senate and House of Representatives of the United States of America in Congress Assembled, that the Act entitled “An act for making further and more effectual provision for the national defense, and other purposes,” approved June 3, 1916, as amended, be, and the same is hereby, amended so that the Air Service referred to in that Act and all subsequent Acts of Congress shall be known as the Air Corps.")]), _vm._v(" "), _c('p', {
    staticClass: "center0"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Public Law 69-446, 2 July 1926")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pii_01.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68e83fe4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Frontmatter.vue
// module id = 60
// module chunks = 0